import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../stylesheets/resource.scss";
import { Button, FormGroup, Label } from "reactstrap";
import { Formik } from "formik";
import axios from "axios";
import { Project_APIs } from "./Project_APIs";
import { UserConsumer } from "../../UserContext";
import Header from "../timesheetModule/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { Redirect } from "react-router-dom";
let token = null;

class ProjectDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			date: new Date().toDateString(),
			projectDetails: {},
			allocateTo: [],
		};
		this.goBack = this.goBack.bind(this);
	}
	goBack() {
		this.props.history.goBack();
	}
	componentDidMount() {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${Project_APIs.GetProjectDetails_API}/${this.props.match.params.projectId}/GetProjectDetails`,
				{ headers: headers }
			)
			.then((res) => {
				this.setState({
					projectDetails: res.data.projectDetails,
					allocateTo: res.data.allocateTo,
				});
			});
	}
	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;

					return userDetails.designation.toString() === "4" ||
						userDetails.id.toString() === "180" ||
						userDetails.id.toString() === "269" ? (
						<div className="container-fluid pl-4 pr-4">
							<Header
								title={this.state.projectDetails.projectName}
							/>
							<div className="mb-2 row col-md-12">
								<Button
									type="button"
									className="back_Button"
									onClick={() => {
										this.goBack();
									}}
								>
									<FontAwesomeIcon
										icon={faChevronLeft}
										size="1x"
									/>
								</Button>
							</div>
							<Formik initialValues={this.projectDetails}>
								<form className="detailsScreen col-md-12">
									<FormGroup row id="row0" className="mb-0">
										<Label sm={12}>
											Project id#{" "}
											{this.props.match.params.projectId}
										</Label>
									</FormGroup>
									<FormGroup
										row
										sm={12}
										className="bottom-spacing row1"
									>
										<Label sm={3}>Project Name:</Label>
										<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
											<span sm={3} className="dataSpan ">
												{
													this.state.projectDetails
														.projectName
												}
											</span>
										</div>
										<Label sm={3}>Project Type:</Label>
										<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
											<span className="dataSpan">
												{this.state.projectDetails
													.projectType === null
													? "N/A"
													: this.state.projectDetails
															.projectType}
											</span>
										</div>
									</FormGroup>
									<FormGroup
										row
										sm={12}
										className="bottom-spacing row2"
									>
										<Label sm={3}>Supervisor:</Label>
										<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
											<span sm={3} className="dataSpan ">
												{this.state.projectDetails
													.supervisorName === null
													? "N/A"
													: this.state.projectDetails
															.supervisorName}
											</span>
										</div>
										<Label htmlFor="Person" sm={3}>
											Project Status:
										</Label>
										<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
											<span sm={3} className="dataSpan ">
												{this.state.projectDetails
													.projectStatus === 1
													? "Active"
													: this.state.projectDetails
															.projectStatus === 0
													? "InActive"
													: this.state.projectDetails
															.projectStatus}
											</span>
										</div>
									</FormGroup>
									<FormGroup
										row
										className="bottom-spacing row1"
									>
										<Label sm={3}>Team:</Label>
										<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow ">
											<span sm={3} className="dataSpan ">
												{this.state.allocateTo.map(
													(allocateTo, index) => (
														<span
															key={index}
															className="dataSpan"
														>
															{(index
																? "\xa0\xa0,\xa0\xa0"
																: "") +
																allocateTo.name}
														</span>
													)
												)}
											</span>
										</div>
									</FormGroup>
									<FormGroup
										row
										className="bottom-spacing row2"
									>
										<Label sm={3}>Notes:</Label>
										<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
											<span sm={3} className="dataSpan">
												{this.state.projectDetails
													.notes === ""
													? "N/A"
													: this.state.projectDetails
															.notes}
											</span>
										</div>
									</FormGroup>
								</form>
							</Formik>
						</div>
					) : (
						<Redirect to="/MyDashboard" />
					);
				}}
			</UserConsumer>
		);
	}
}
export default ProjectDetails;
